import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateWarehouseStockApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateWarehouseStock = createAsyncThunk('updateWarehouseStock', async (payload) => {
  return await updateWarehouseStockApi(payload);
});

const updateWarehouseStockSlice = createSlice({
  name: 'updateWarehouseStock', // Unique Name
  initialState,
  reducers: {
    updateWarehouseStockReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateWarehouseStock.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateWarehouseStock.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateWarehouseStock.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateWarehouseStockReset } = updateWarehouseStockSlice.actions;

export default updateWarehouseStockSlice.reducer;
